// https://www.dbos.dev/contact

import { contactForm } from '@lib/hubspot';
import { SiteLayout } from '@components/layout/SiteLayout';
import { FooterCtaBuildYourReliableBackend, FooterLinksSendUsMail } from '@components/layout/FooterCtas';
import { FormDone, FormElement, FormFail, WebflowForm } from '@components/webflow';

export function ContactPage() {
  return (
    <SiteLayout
      banner={true}
      footerCta={
        <>
          <FooterCtaBuildYourReliableBackend />
          <FooterLinksSendUsMail />
        </>
      }
    >
      <section className="hero-title">
        <h1 className="text-heading-h1">Contact us</h1>
        <p className="text-body text-alignment-left">Reach out to DBOS and our team will reply as soon as possible.</p>
      </section>
      <div className="card-contact-wrapper">
        <div className="contact-content-left">
          <WebflowForm className="form-block-2 w-form">
            <FormElement
              id="contact"
              name="wf-form-Contact"
              data-name="Contact"
              method="get"
              className="contact-form"
              hubspot={contactForm}
            >
              <div className="input-group">
                <label htmlFor="First-name" className="input-label">
                  First name
                  <span className="label-required">
                    <sup>*</sup>
                  </span>
                </label>
                <input
                  className="input-field w-input"
                  maxLength={256}
                  name="First-name"
                  data-name="First name"
                  placeholder="Enter your first name"
                  type="text"
                  id="First-name"
                  required
                />
              </div>
              <div className="input-group">
                <label htmlFor="Last-name" className="input-label">
                  Last name
                  <span className="label-required">
                    <sup>*</sup>
                  </span>
                </label>
                <input
                  className="input-field w-input"
                  maxLength={256}
                  name="Last-name"
                  data-name="Last name"
                  placeholder="Enter your last name"
                  type="text"
                  id="Last-name"
                  required
                />
              </div>
              <div className="input-group">
                <label htmlFor="Company" className="input-label">
                  Company
                  <span className="label-required">
                    <sup>*</sup>
                  </span>
                </label>
                <input
                  className="input-field w-input"
                  maxLength={256}
                  name="Company"
                  data-name="Company"
                  placeholder="Where do you work?"
                  type="text"
                  id="Company"
                  required
                />
              </div>
              <div className="input-group">
                <label htmlFor="Email" className="input-label">
                  Email
                  <span className="label-required">
                    <sup>*</sup>
                  </span>
                </label>
                <input
                  className="input-field w-input"
                  maxLength={256}
                  name="Email"
                  data-name="Email"
                  placeholder="Enter your email"
                  type="email"
                  id="Email"
                  required
                />
              </div>
              <div id="w-node-a5d58c64-af92-99cb-c837-adb339129edd-68c9e67b" className="input-large">
                <label htmlFor="Message" className="input-label">
                  Message
                  <span className="label-required">
                    <sup>*</sup>
                  </span>
                </label>
                <textarea
                  required
                  placeholder="How can we help?"
                  maxLength={5000}
                  id="Message"
                  name="Message"
                  data-name="Message"
                  className="input-field w-input"
                />
              </div>
              <div className="button-primary-border">
                <input
                  type="submit"
                  data-wait="Please wait..."
                  className="button-cta button-primary w-button"
                  defaultValue="Send your message"
                />
              </div>
            </FormElement>
            <FormDone className="success-message w-form-done">
              <div className="text-body">Thank you! Your submission has been received!</div>
            </FormDone>
            <FormFail className="error-message w-form-fail">
              <div className="text-body">
                Oops, something went wrong!
                <br />
                Please verify your details and try again.
              </div>
            </FormFail>
          </WebflowForm>
          <div className="text-caption-micro">
            {
              'We need the information you provide to contact you about our products and services. You may unsubscribe from these communications at any time. For information on how to unsubscribe, as well as our privacy practices and commitment to protecting your privacy, please review our '
            }
            <a href="/privacy" target="_blank" className="text-body-link">
              {'Privacy Policy. '}
            </a>
          </div>
        </div>
        <div className="contact-content-right">
          <div className="text-body text-alignment-left">
            <span className="text-body-highlight">Send us mail</span>
            <br />
            DBOS, Inc.
            <br />
            68 Harrison Ave Ste 605 PMB 66880
            <br />
            Boston, MA 02111-1929
          </div>
          <div className="text-body text-alignment-left">
            <span className="text-body-highlight">Join us on Discord</span>
            <br />
            #dbosdev
          </div>
          <div className="text-body text-alignment-left">
            <span className="text-body-highlight">
              Follow our GitHub
              <br />
              {'\u200d'}
            </span>
            dbos-inc
          </div>
        </div>
      </div>
    </SiteLayout>
  );
}
